import { BaseFlexShapeMain } from './base-flex-shape/BaseFlexShapeMain';
import { CarbonFreeMain } from './carbon-free/CarbonFreeMain';
import { FlexHoursMain } from './flex-hours/FlexHoursMain';
import { ForecastingMain } from './forecasting/ForecastingMain';
import { GeneralMain } from './general/GeneralMain';
import { ImportTradesMain } from './import-trades/ImportTradesMain';
import { OptInMain } from './opt-in/OptInMain';
import { OptOutMain } from './opt-out/OptOutMain';
import { OfferSelectMain } from './offer-select/OfferSelectMain';
import { UniformDailyMain } from './uniform-daily/UniformDailyMain';

export class TemplateHelper {
  static resolveComponent(templateName) {
    switch (templateName) {
      case 'BASE_FLEX_SHAPE': return BaseFlexShapeMain;
      case 'CARBON_FREE': return CarbonFreeMain;
      case 'FLEX_HOURS': return FlexHoursMain;
      case 'FORECASTING': return ForecastingMain;
      case 'GENERAL': return GeneralMain;
      case 'IMPORT_TRADES': return ImportTradesMain;
      case 'OPT_IN': return OptInMain;
      case 'OPT_OUT': return OptOutMain;
      case 'OFFER_SELECT': return OfferSelectMain;
      case 'UNIFORM_DAILY': return UniformDailyMain;
      default: return undefined;
    }
  }
}
